import React from "react";
import { IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const CollapseToggle = ({ open, setOpen }) => {
  return (
    <div onClick={() => setOpen(!open)} sx={{ display: { xs: "none", sm: "flex" } }}>
      {open ? (
        <ChevronRight style={{ color: "white" }} />
      ) : (
        <ChevronLeft style={{ color: "white" }} />
      )}
    </div>
  );
};

export default CollapseToggle;